import api from '../config/api';

export const rideService = {
  // Request a new ride
  async requestRide(rideData) {
    try {
      const response = await api.post('/rides/request', rideData);
      return response.data;
    } catch (error) {
      console.error('Request ride error:', error);
      throw error;
    }
  },

  // Get fare estimate from backend
  async getFareEstimate(pickupCoords, dropoffCoords, type = 'STANDARD') {
    try {
      const response = await api.get('/rides/estimate', {
        params: {
          pickupLat: pickupCoords.latitude,
          pickupLng: pickupCoords.longitude,
          dropoffLat: dropoffCoords.latitude,
          dropoffLng: dropoffCoords.longitude,
          type,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Fare estimate error:', error);
      throw error;
    }
  },

  // Get ride history with pagination
  async getRideHistory(page = 1, limit = 20) {
    try {
      const response = await api.get(`/rides/history?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Get ride history error:', error);
      throw error;
    }
  },

  // Get ride details by ID
  async getRideById(rideId) {
    try {
      const response = await api.get(`/rides/${rideId}`);
      return response.data;
    } catch (error) {
      console.error('Get ride details error:', error);
      throw error;
    }
  },

  // Cancel a ride
  async cancelRide(rideId) {
    try {
      const response = await api.post('/rides/cancel', { rideId });
      return response.data;
    } catch (error) {
      console.error('Cancel ride error:', error);
      throw error;
    }
  },

  // Rate a completed ride
  async rateRide(rideId, rating, feedback) {
    try {
      const response = await api.post('/rides/rate', { rideId, rating, feedback });
      return response.data;
    } catch (error) {
      console.error('Rate ride error:', error);
      throw error;
    }
  },

  // Get nearby available drivers for map display
  async getNearbyDrivers(latitude, longitude) {
    try {
      const response = await api.get('/rides/nearby-drivers', {
        params: { lat: latitude, lng: longitude },
      });
      return response.data;
    } catch (error) {
      console.error('Get nearby drivers error:', error);
      throw error;
    }
  },

  // Get rider's current active ride
  async getActiveRide() {
    try {
      const response = await api.get('/rides/active');
      return response.data;
    } catch (error) {
      console.error('Get active ride error:', error);
      throw error;
    }
  },

  // Get profile
  async getProfile() {
    try {
      const response = await api.get('/auth/profile');
      return response.data;
    } catch (error) {
      console.error('Get profile error:', error);
      throw error;
    }
  },

  // Update profile
  async updateProfile(data) {
    try {
      const response = await api.put('/auth/profile', data);
      return response.data;
    } catch (error) {
      console.error('Update profile error:', error);
      throw error;
    }
  },

  // Change password
  async changePassword(currentPassword, newPassword) {
    try {
      const response = await api.put('/auth/change-password', { currentPassword, newPassword });
      return response.data;
    } catch (error) {
      console.error('Change password error:', error);
      throw error;
    }
  },
};
